import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { EulaAcceptancePageComponent } from "./eula-acceptance-page.component";

export const eulaAcceptancePageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-eula-acceptance-page", EulaAcceptancePageComponent)
    .withTitle("Accept Customer License Agreement")
    .atUrl("/accept-license-agreement")
    .requiresLogin(false)
    .build();
